/**
 * @typedef {Object} Invoice
 * @property {string} amount
 * @property {string} createdDate
 * @property {number} id
 * @property {string} number
 * @property {Object} promocode
 * @property {boolean} canGenerateReceipt
 * @property {boolean} isFamilyService
 * @property {boolean} hideInvoice
 * @property {{id: number, name: string}[]} products
 * @property {Object} service
 * @property {number} service.price
 * @property {number} service.id
 * @property {string} service.name
 * @property {Object} status
 * @property {number} status.id
 * @property {string} status.name
 * @property {InvoiceStudent[]} students
 * @property {string} url
 */

/**
 * @typedef {Object} InvoiceStudent
 * @property {number} id
 * @property {string} name
 */

/**
 * @typedef {Object} OfferDoc
 * @property {number} id
 * @property {string} name
 * @property {Object} product
 * @property {number} product.id
 * @property {string} product.name
 * @property {number} purchaseId
 * @property {number} purchaseItemId
 * @property {string} blob
 * @property {boolean} isChecked
 */

export default () => ({
  /**
   * @type {Invoice[]}
   */
  invoices: [],

  invoice: {
    id: null,
    number: null,
    amount: null,
    url: null,
    createdDate: null,
    status: null,
    service: null,
    products: [],
    students: [],
    canGenerateReceipt: false,
    needAgreeWithOffer: false,
    diagnosticsOfferId: null,
    isFamilyService: false,
    hideInvoice: false,

    promocode: {
      id: null,
      code: null,
      bestBefore: null,
      status: null,

      group: {
        id: null,
        name: null,
        bestBefore: null,
        initialGeneratedCount: null,
        discount: null,
        newPromocodesCount: null,
        usedPromocodesCount: null,
        expiredPromocodesCount: null,
        discountType: null,
      },
    },
  },

  paymentUrl: '',
  diagnosticsOfferDoc: '',
  hasFamilyInvoice: false,
  /**
   * @type {OfferDoc[]}
   */
  offerDocs: [],
  serverTimestamp: 0,
})
